import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use(CKEditor);

Vue.config.productionTip = false

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

import msal from 'vue-msal'

Vue.use(msal, {
  auth: {
    clientId: '847f012d-97e0-467c-b5ce-8bc85da325a4',
    authority: 'https://login.microsoftonline.com/f3fb51ec-a7c2-491b-bbf7-f9d5859b433d',
    //redirectUri: 'https://dev.petra.huntingperformance.io',
    redirectUri: process.env.VUE_APP_REDIRECTURI || 'https://dev.petra.huntingperformance.io',
    requireAuthOnInitialize: true
  },
  request: {
    scopes: ['user.read']
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true
  },
  graph: {
    callAfterInit: false,
    endPoints: {
      profile: '/me'
    }
  },
  framework: {
    globalMixin: true
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')